export default function SectionBox({ children, className = "" }) {
    return (
        <section className="relative w-full flex justify-center px-4">
            <div
                className={`
                    w-full
                    bg-transparent
                    ${className}
                `}
            >
                {children}
            </div>
        </section>
    );
}
